( function () {

  document.addEventListener( 'DOMContentLoaded', () => {
    const sections = document.querySelectorAll( '.schema-faq-section' );
  
    function collapseAll() {
      sections.forEach( section => {
        section.classList.remove( 'active' );
        const answer = section.querySelector( '.schema-faq-answer' );
        answer.style.height = '0px';
      } );
    }
  
    sections.forEach( ( section, index ) => {
      const answer = section.querySelector( '.schema-faq-answer' );
      const question = section.querySelector( '.schema-faq-question' );
  
      // Setup transition
      answer.style.overflow = 'hidden';
      answer.style.transition = 'height 0.3s ease-in-out';
  
      // Expand first section by default
      if ( index === 0 ) {
        section.classList.add( 'active' );
        answer.style.height = answer.scrollHeight + 'px';
      } else {
        answer.style.height = '0px';
      }
  
      // Only bind click event to the question
      question.style.cursor = 'pointer';
      question.addEventListener( 'click', ( e ) => {
        e.stopPropagation(); // prevent bubbling just in case
  
        const isActive = section.classList.contains( 'active' );
  
        if ( isActive ) {
          section.classList.remove( 'active' );
          answer.style.height = '0px';
        } else {
          collapseAll();
          section.classList.add( 'active' );
          answer.style.height = answer.scrollHeight + 'px';
        }
      } );
    } );
  
    // Auto-adjust expanded panel height on window resize
    window.addEventListener( 'resize', () => {
      document.querySelectorAll( '.schema-faq-section.active .schema-faq-answer' )
        .forEach( answer => {
          answer.style.height = answer.scrollHeight + 'px';
        } );
    } );
  } );
} )();